// Datas e preferência da decoração de Natal (mesma regra do r2-oauth-2.0-front).

// Último dia da decoração em janeiro: tudo (Natal e Réveillon) some a partir do dia 12
export const SEASON_LAST_DAY = 11;

// De 1º de novembro a 11 de janeiro
export function isChristmasSeason(date = new Date()) {
    const month = date.getMonth();
    return month === 10 || month === 11 || (month === 0 && date.getDate() <= SEASON_LAST_DAY);
}

// Saudação curta: muda nas datas que importam
export function seasonGreeting(date = new Date()) {
    const month = date.getMonth();
    const day = date.getDate();
    if (month === 11 && (day === 24 || day === 25)) return 'Feliz Natal';
    // Réveillon: o ano que chega (no dia 31, já o seguinte)
    if (isNewYear(date)) return `Feliz ${month === 11 ? date.getFullYear() + 1 : date.getFullYear()}`;
    return 'Boas festas';
}

// Réveillon: 31 de dezembro a 11 de janeiro (no login, fogos no lugar do trenó)
export function isNewYear(date = new Date()) {
    const month = date.getMonth();
    const day = date.getDate();
    return (month === 11 && day === 31) || (month === 0 && day <= SEASON_LAST_DAY);
}

// Título da aba na época: "R2 Assinatura · Boas festas" (e "Feliz Natal" / "Feliz 2027" nas datas)
export function seasonTitle(base, date = new Date()) {
    return isChristmasSeason(date) ? `${base} · ${seasonGreeting(date)}` : base;
}

export const SEASON_FAVICON = '/favicon-natal.ico';

// Favicon com gorro (a mesma arte da logo com gorro) só na época
export function applySeasonFavicon(date = new Date()) {
    if (typeof document === 'undefined' || !isChristmasSeason(date)) return;
    document.querySelectorAll('link[rel~="icon"]').forEach(link => {
        link.href = SEASON_FAVICON;
    });
}

// Mensagem mais longa, no title do selo de festas do cabeçalho
export function seasonMessage(date = new Date()) {
    const month = date.getMonth();
    const day = date.getDate();
    if (month === 11 && (day === 24 || day === 25)) {
        return 'Que o seu Natal seja de paz, saúde e bons momentos com quem você ama.';
    }
    if ((month === 11 && day === 31) || month === 0) {
        return 'Que o novo ano chegue com saúde, energia e ótimos projetos.';
    }
    if (month === 11 && day > 25) {
        return 'Obrigado por estar com a gente em mais um ano. Que venha o próximo!';
    }
    return 'Desejamos a você e à sua equipe um fim de ano de conquistas e boas festas.';
}

// Contagem regressiva do selo de festas: dias até o Natal, dias até o Ano-Novo e, no dia 31, horas e minutos.
// count/unit vêm separados para o número ganhar destaque; text é a frase inteira (leitor de tela e title)
const DAY = 24 * 60 * 60 * 1000;

function daysBetween(from, to) {
    return Math.round((Date.UTC(to.getFullYear(), to.getMonth(), to.getDate())
        - Date.UTC(from.getFullYear(), from.getMonth(), from.getDate())) / DAY);
}

function plural(count, one, many) {
    return count === 1 ? one : many;
}

export function seasonCountdown(date = new Date()) {
    const month = date.getMonth();
    const day = date.getDate();
    const year = date.getFullYear();
    if (month === 0 && day <= SEASON_LAST_DAY) {
        return {count: null, unit: '', label: `Que ${year} seja incrível`, text: `Que ${year} seja incrível`};
    }
    if (month !== 10 && month !== 11) return null;
    const nextYear = year + 1;
    if (month === 11 && day === 31) {
        const left = new Date(nextYear, 0, 1) - date;
        const hours = Math.floor(left / 3600000);
        if (hours >= 1) {
            const unit = plural(hours, 'hora', 'horas');
            return {count: hours, unit, label: `para ${nextYear}`, text: `${plural(hours, 'Falta', 'Faltam')} ${hours} ${unit} para ${nextYear}`};
        }
        const minutes = Math.max(1, Math.ceil(left / 60000));
        const unit = plural(minutes, 'minuto', 'minutos');
        return {count: minutes, unit, label: `para ${nextYear}`, text: `${plural(minutes, 'Falta', 'Faltam')} ${minutes} ${unit} para ${nextYear}`};
    }
    if (month === 11 && day === 25) return {count: null, unit: '', label: 'Hoje é Natal', text: 'Hoje é Natal'};
    if (month === 11 && day === 24) return {count: null, unit: '', label: 'Amanhã é Natal', text: 'Amanhã é Natal'};
    if (month === 11 && day > 25) {
        const days = daysBetween(date, new Date(nextYear, 0, 1));
        return {count: days, unit: 'dias', label: `para ${nextYear}`, text: `Faltam ${days} dias para ${nextYear}`};
    }
    const days = daysBetween(date, new Date(year, 11, 25));
    return {count: days, unit: 'dias', label: 'para o Natal', text: `Faltam ${days} dias para o Natal`};
}


// Cada pessoa pode desligar a animação do sistema (neve); a decoração parada continua
const EFFECTS_KEY = 'christmasEffects';

export function christmasEffectsEnabled() {
    try {
        return localStorage.getItem(EFFECTS_KEY) !== 'off';
    } catch {
        return true;
    }
}

export function saveChristmasEffects(enabled) {
    try {
        if (enabled) localStorage.removeItem(EFFECTS_KEY);
        else localStorage.setItem(EFFECTS_KEY, 'off');
    } catch {
        // Armazenamento bloqueado: vale só nesta sessão
    }
}

export function prefersReducedMotion() {
    return typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
}

// Cartão de festas da home: quem fecha guarda no selo do cabeçalho. Fica gravada a mensagem fechada,
// então quando ela muda (Natal, fim de ano, Ano-Novo) o cartão volta para a home
const GREETING_DOCKED_KEY = 'christmasGreetingDocked';

export function christmasGreetingDocked(message = seasonMessage()) {
    try {
        return localStorage.getItem(GREETING_DOCKED_KEY) === message;
    } catch {
        return false;
    }
}

export function saveChristmasGreetingDocked(docked, message = seasonMessage()) {
    try {
        if (docked) localStorage.setItem(GREETING_DOCKED_KEY, message);
        else localStorage.removeItem(GREETING_DOCKED_KEY);
    } catch {
        // Armazenamento bloqueado: vale só nesta sessão
    }
}

// Estrela de cinco pontas (viewBox -12 -12 24 24) do selo, do cartão e da estrela que voa
export const STAR_PATH = 'M0 -11 L3 -3.6 L11 -3.4 L4.8 1.6 L7 9.6 L0 5 L-7 9.6 L-4.8 1.6 L-11 -3.4 L-3 -3.6 Z';
